import React, { useState } from "react";
import IconDeltete from "../../assets/images/icon-delete.png";
import { uploadFiles } from "api/postApi";
import { toast } from "react-toastify";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { t } from "i18next";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, UploadProps } from "antd";
import { Spinner } from "reactstrap";
import { getURLWithDomain } from "utils";
import FileReader from "./FileRender";
import ModalPreview from "./ModalPreview";

const props: UploadProps = {
  name: "files",
  accept: "*",
  beforeUpload: () => false,
  headers: {
    authorization: "authorization-text",
  },
};

const UploadFile = ({
  isMultiple = true,
  uploadProps,
  isUploadMore = false,
  isListURLString = false,
  isDisabled = false,
  attachments,
  setAttachments,
  maxCount,
}: any) => {
  const [isLoadingUploadImage, setIsLoadingUploadImage] =
    useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>();

  const onCloseImageClick = () => {
    setLinkImage((_prev: any) => null);
  };

  return (
    <React.Fragment>
      <div>
        <div className="d-flex gap-3 flex-wrap mt-2 mb-2">
          {attachments?.map((i: any, index: number) => {
            const path = i?.path.includes("https")
              ? i?.path
              : `${process.env.REACT_APP_UPLOAD_URL}/${i?.path}`;
            console.log(path);
            if (i?.type == "video")
              return (
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <video
                    width="160"
                    height="120"
                    controls
                    key={path}
                    onClick={() => {
                      const newItem = {
                        type: "VIDEO",
                        url: path,
                      };
                      setLinkImage(newItem);
                    }}
                  >
                    <source src={path} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <span
                    onClick={() => {
                      const newFilesList = [...attachments];
                      newFilesList.splice(index, 1);
                      setAttachments(newFilesList);
                    }}
                    style={{
                      color: "red",
                      position: "absolute",
                      top: "-12px",
                      right: "-5px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={IconDeltete}
                      alt="delete"
                      width={18}
                      height={18}
                    />
                  </span>
                </div>
              );

            if (i?.type == "image")
              return (
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <div>
                    <div style={{ width: "90px" }} className="cursor-pointer">
                      <img
                        src={path}
                        className="flex-shrink-0 rounded w-100"
                        alt="thumbnail"
                        onClick={() => {
                          const newItem = {
                            type: "IMAGE",
                            url: path,
                          };
                          setLinkImage(newItem);
                        }}
                      />
                    </div>
                  </div>
                  <span
                    onClick={() => {
                      const newFilesList = [...attachments];
                      newFilesList.splice(index, 1);
                      setAttachments(newFilesList);
                    }}
                    style={{
                      color: "red",
                      position: "absolute",
                      top: "-12px",
                      right: "-5px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={IconDeltete}
                      alt="delete"
                      width={18}
                      height={18}
                    />
                  </span>
                </div>
              );
            return (
              <div
                style={{
                  position: "relative",
                }}
              >
                <FileReader file={i} />
                <span
                  onClick={() => {
                    const newFilesList = [...attachments];
                    newFilesList.splice(index, 1);
                    setAttachments(newFilesList);
                  }}
                  style={{
                    color: "red",
                    position: "absolute",
                    top: "-12px",
                    right: "-5px",
                    cursor: "pointer",
                  }}
                >
                  <img src={IconDeltete} alt="delete" width={18} height={18} />
                </span>
              </div>
            );
          })}
        </div>

        <div>
          <Upload
            {...(uploadProps ? uploadProps : props)}
            multiple={isMultiple}
            beforeUpload={() => false}
            fileList={[]}
            maxCount={maxCount || 10}
            onChange={async (info: any) => {
              setIsLoadingUploadImage(true);
              try {
                const cloneInfo = info?.fileList?.length
                  ? [...info?.fileList]
                  : [];

                const files = info.fileList;
                const data = new FormData();
                for (var i = 0; i < files?.length; i++) {
                  data.append("files", files[i]?.originFileObj);
                }

                const res = (await uploadFiles(data)) as any;
                if (res?.code === 200) {
                  setIsLoadingUploadImage(false);
                  const fortmatedData = res?.data?.map(
                    (i: any, index: number) => {
                      if (isListURLString === true) {
                        return i?.filepath;
                      }

                      let type = cloneInfo[index]?.type || "file";
                      if (cloneInfo[index]?.type.includes("video"))
                        type = "video";
                      if (cloneInfo[index]?.type.includes("image"))
                        type = "image";

                      return {
                        filename: i?.filename,
                        type, // image, video, file
                        path: i?.filepath,
                        size_file: i?.size || 0,
                        thumbnail: i?.filepath,
                      };
                    }
                  );
                  const newFiles = !isUploadMore
                    ? fortmatedData
                    : [...fortmatedData, ...attachments];

                  setAttachments(newFiles);
                } else {
                  setIsLoadingUploadImage(false);
                }
              } catch (error: any) {
                setIsLoadingUploadImage(false);
                toast(
                  `${t("Input buffer contains unsupported image format")}`,
                  CONFIG_OPTION_TOAST_ERROR
                );
              }
            }}
            onRemove={() => {
              //return onGalleryFileRemove();
            }}
          >
            {/* <Button icon={<UploadOutlined />}>
                    {t("Click to Upload")}
                  </Button> */}
            {!isDisabled && (
              <Button
                disabled={isLoadingUploadImage}
                icon={
                  isLoadingUploadImage ? (
                    <Spinner size="sm" className="text-primary"></Spinner>
                  ) : (
                    <UploadOutlined />
                  )
                }
              >
                {isUploadMore && attachments?.length > 0
                  ? t("Upload More")
                  : t("Click to Upload")}
              </Button>
            )}
          </Upload>
        </div>
      </div>
      <ModalPreview
        type={linkImage?.type}
        isOpen={!!linkImage}
        url={linkImage?.url}
        onClose={() => onCloseImageClick()}
      />
    </React.Fragment>
  );
};

export default UploadFile;
